<template>
  <div class="c-default-img">
    <img class="img" v-if="src" :src="src" />
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 80,
    },
  },
  data() {
    return {
      s: 80,
    }
  },
  mounted() {
    this.s = this.ratio * this.size + 'px'
  },
}
</script>

<style scoped lang="less">
.c-default-img{
  display: inline-block;
  width: v-bind(s);
  height: v-bind(s);
  border-radius: 50%;
  img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}
</style>